import "./TrialInformation.css";

import { TrialPreferences } from "../TrialPreferences/TrialPreferences";

export const PlotMapDetails = () => (
  <div className="plotmap-description">
    <TrialPreferences onPlotMap />
  </div>
);
